module.exports = __webpack_public_path__ + "static/img/laser_pen_red.ed09d930.jpg";